import firebase from 'firebase';

const state = [
  {
    assessments: [],
    display_name: "Jens Groß", 
    email: "jens.gross@m.works", 
    email_verified:  true,
    first_name: "Jens",
    id: "colleague1",
    last_name: "Groß",
    last_login: "2020-10-01T14:48:00", 
    organisation: ["RoHvoiRymMd4N2B"],
    profile_image: 'https://cdn.vuetifyjs.com/images/lists/2.jpg'
  },
  {
    assessments: [],
    display_name: "Simon Dogan", 
    email: "simon.dogan@m.works", 
    email_verified:  true,
    first_name: "Simon",
    id: "colleague2",
    last_name: "Dogan",
    last_login:  "2020-09-30T10:28:00", 
    organisation: ["RoHvoiRymMd4N2B"],
    profile_image: 'https://cdn.vuetifyjs.com/images/lists/1.jpg'
  },
  {
    assessments: [],
    display_name: "Rita Meister", 
    email: "rita.meister@m.works", 
    email_verified: false,
    first_name: "Rita",
    id: "colleague3",
    last_name: "Meister",
    last_login:  false,
    organisation: ["RoHvoiRymMd4N2B"],
    profile_image: 'https://cdn.vuetifyjs.com/images/lists/3.jpg'
  }
];

const actions = {
  getOne({commit}, id){
    var subscription = firebase.firestore().doc(`users/${id}`).onSnapshot(doc => {
      var user =  doc.data();
      user.id = doc.id;
      commit("SET_ONE",  {doc: user, collection: "users"}, {root:true} )
    })
    commit("auth/LOG_SUBSCRIPTION", subscription, {root: true})
  },
  getAll({ commit }){
    
    var subscription = firebase.firestore().collection("users").onSnapshot(snap => {
      snap.forEach( doc => {
        var user = doc.data()
        user.id = doc.id;
        commit("SET_ONE",  {doc: user, collection: "users"}, {root:true} )  
      })
    });
    commit("auth/LOG_SUBSCRIPTION", subscription, {root: true})
  },
  addUser({commit}, user){
    user.created_by = firebase.auth().currentUser.uid;
    user.email_verified = false;
    commit("ADD_USER", user);
    return user; 
  }
} 

const mutations = {
  ADD_USER(state, user){
    //TODO - Should i be using Vue.set() on the whole array here? there is no push function
    state.push(user);
  }  
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
